import React from 'react';
import Modal from '@material-ui/core/Modal';
import { Box } from '@material-ui/core';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  height: 200,
  width: 330,
  bgcolor: 'background.paper',
  border: '1px solid #59b9ea',
  borderColor: 'primary.light',
  boxShadow: 24,
  p: 3,
};

export default function MatrialInputListMessage(props) {
  // const classes = useStyles();

  const handleClose = () => {
    props.setMatrialInputListMessageModal(false);
  };

  return (
    <div>
      <Modal open={props.matrialInputListMessageModal} >
        <Box sx={style}>

          <h5 style={{textAlign:'center', backgroundColor:'greenyellow'}}>2023-12-05일 이후부터 부가세 등록할것</h5>
          <ol>
            <li>부가세 항목추가됨</li>
            <li>세금계산서 항목 추가됨</li>
            <li>이 메세지는 2024년까지만 나타남 </li>
          </ol>

          <button type="button" onClick={handleClose}>
            닫기
          </button>
        </Box>
      </Modal>
    </div>
  );
}